import { Subject } from 'rxjs';

export interface NickNameModal {
    isRewardPage: boolean;
    isOpen: boolean;
}
export interface ModalState {
	isOpen: boolean; 
	props?: JupiterMessageModalData;
}
export interface JupiterMessageModalData {
	title: string;
	message: string;
	eventKey?: string;
}

const loginModal$ = new Subject<boolean>();
const messageModal$ = new Subject<string>();
const depositNowModal$ = new Subject<boolean>();
const jupiterMessageModal$ = new Subject<ModalState>();
const jupiterLogoutMessageModal$ = new Subject<ModalState>();
const newbieTutorialModal$ = new Subject<boolean>();
const bankInfoAlertModal$ = new Subject<boolean>();
const goldenDuelToolTipModal$ = new Subject<boolean>();

const openLoginModal = () => loginModal$.next(true);
const openMessageModal = (message: string) => messageModal$.next(message);
const openDepositNowModal = () => depositNowModal$.next(true);
const openJupiterMessageModal = (props: JupiterMessageModalData) => jupiterMessageModal$.next({ isOpen: true, props });
const closeJupiterMessageModal = (eventKey: string) => jupiterMessageModal$.next({ isOpen: false, props: { title: '', message: '', eventKey } });

const openJupiterLogoutMessageModal = (props: JupiterMessageModalData) => jupiterLogoutMessageModal$.next({ isOpen: true, props });
const closeJupiterLogoutMessageModal = () => jupiterLogoutMessageModal$.next({ isOpen: false, props: { title: '', message: '', eventKey: 'JupiterLogout' } });

const openNewbieTutorialModal = () => newbieTutorialModal$.next(true);

const nickNameModal$ = new Subject<NickNameModal>();
const openNickNameModal = (isRewardPage: boolean, isOpen: boolean) => nickNameModal$.next({ isRewardPage, isOpen });

const openBankInfoAlertModal = (isOpen: boolean) => bankInfoAlertModal$.next(isOpen);
const openGoldenDuelToolTipModal = (isOpen: boolean) => goldenDuelToolTipModal$.next(isOpen);

export const modalService = {
	onOpenLoginModel: loginModal$.asObservable(),
	onOpenDepositNowModal: depositNowModal$.asObservable(),
	onOpenMessageModal: messageModal$.asObservable(),
	onOpenJupiterMessageModal: jupiterMessageModal$.asObservable(),
	onOpenJupiterLogoutMessageModal: jupiterLogoutMessageModal$.asObservable(),
	onOpenNewbieTutorialModal: newbieTutorialModal$.asObservable(),
	openLoginModal,
	openMessageModal,
	openDepositNowModal,
	openJupiterMessageModal: openJupiterMessageModal,
	closeJupiterMessageModal: closeJupiterMessageModal,
	openJupiterLogoutMessageModal: openJupiterLogoutMessageModal,
	closeJupiterLogoutMessageModal: closeJupiterLogoutMessageModal,
	openNewbieTutorialModal,
	onOpenNickNameModal: nickNameModal$.asObservable(),
	openNickNameModal,
	onOpenBankInfoAlertModal: bankInfoAlertModal$.asObservable(),
	openBankInfoAlertModal: openBankInfoAlertModal,
	onOpenGoldenDuelToolTipModal: goldenDuelToolTipModal$.asObservable(),
	openGoldenDuelToolTipModal: openGoldenDuelToolTipModal
}
